export default __webpack_public_path__ + "static/media/icons-user-group-green-32-px.3c516d21.svg";